import { render, staticRenderFns } from "./Movements.vue?vue&type=template&id=4e24432c&scoped=true"
import script from "./Movements.vue?vue&type=script&lang=js"
export * from "./Movements.vue?vue&type=script&lang=js"
import style0 from "./Movements.vue?vue&type=style&index=0&id=4e24432c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e24432c",
  null
  
)

export default component.exports